import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type OttoAiState = {
  isTourOpen: boolean
  isModalOpen: boolean
  hasSeenOnboarding: boolean
  hasSeenSpotlight: boolean
}

type OttoAiActions = {
  openTour: () => void
  closeTour: () => void
  openModal: () => void
  closeModal: () => void
  markOnboardingSeen: () => void
  markSpotlightSeen: () => void
  reset: () => void
}

type OttoAiStore = OttoAiState & OttoAiActions

const initialState: OttoAiState = {
  isTourOpen: false,
  isModalOpen: false,
  hasSeenOnboarding: false,
  hasSeenSpotlight: false
}

export const useOttoAiStore = create<OttoAiStore>()(
  persist(
    (set, get) => ({
      ...initialState,

      openTour: () => set({ isTourOpen: true }),

      closeTour: () => {
        set({ isTourOpen: false, hasSeenSpotlight: true })
      },

      openModal: () => set({ isModalOpen: true }),

      closeModal: () => {
        set({ isModalOpen: false, hasSeenOnboarding: true })
      },

      markOnboardingSeen: () => set({ hasSeenOnboarding: true }),

      markSpotlightSeen: () => set({ hasSeenSpotlight: true }),

      reset: () => {
        set(initialState)
      }
    }),
    {
      name: 'otto-ai-store',
      partialize: state => ({
        hasSeenOnboarding: state.hasSeenOnboarding,
        hasSeenSpotlight: state.hasSeenSpotlight
      }),
      storage: {
        getItem: name => {
          const str = localStorage.getItem(name)
          return str ? JSON.parse(str) : null
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: name => {
          localStorage.removeItem(name)
        }
      }
    }
  )
)
